// extracted by mini-css-extract-plugin
module.exports = {"point":"NumberPoint_point__2q9QQ","current":"NumberPoint_current__ZAj8q","checked":"NumberPoint_checked__28xSj"};